<template>
<sdPageHeader>
<template #title>
 <div headless>
 <ProductCard
    class="list-view"
    :style="{ width: '100%', marginBottom: '10px' }"
    >
    <div class="product-list" style="padding: 10px;background-color:#ffffff;">
    
        <!--<BasicFormWrapper>-->
            <a-form
              name="contact"
              :rules="rules"
              :model="formState"
              @submit="handleOk"
              :layout="formState.layout"
            >
            <a-row :gutter="20">
            <a-col :md="6">
              <a-form-item name="dateSelection" label="DateFilter:">
                <a-select
                  v-model:value="formState.dateSelection"
                  showSearch
                  @change="onChange"
                >
                    <a-select-option value="Today">Today</a-select-option>
                    <a-select-option value="Yesterday">Yesterday</a-select-option>
                    <a-select-option value="Last 7 Days">Last 7 Day's</a-select-option>
                    <a-select-option value="This Month">This Month</a-select-option>
                    <a-select-option value="Custom Range">Custom Range</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6">
              <a-form-item name="domain" label="Domain:">
                <a-select
                  v-model:value="formState.domain"
                  showSearch
                  placeholder="Select Domain"
                >
                  <a-select-option
                    v-for="item in orgData"
                    :key="item.organization"
                    :value="item.organization"
                  >{{ item.organization }}</a-select-option>
                </a-select>
              </a-form-item>
             </a-col>
            <a-col :md="7" v-if="dispInterest">
            <a-form-item name="date-range" label="DateRange:">
             <a-range-picker
                  style="padding-top: 10px !important"
                  @change="DateSelect"
                  :defaultValue="selectrange"
                />   
            </a-form-item>
            </a-col>
            
            <a-col :md="4">
            <a-form-item>
              <a-button 
                htmlType="submit"
                size="default"
                type="primary"
                key="submit"
                class="btn-add_new"
                style="margin-top: -1.5px !important;"
              >
               <span style="display: inline-flex !important;
              align-items: center !important;">
              <sdFeatherIcons type="arrow-down-circle" size="14" />  &nbsp; 
              Get Counts</span>
              </a-button>
             </a-form-item>
              </a-col>
             
              </a-row>
            </a-form>

          <!--</BasicFormWrapper>-->
          
          </div>
          </ProductCard>
  <router-link to="/sclsprint/1">
    <ProductCard
    class="list-view"
    :style="{ width: '15%', marginBottom: '20px' }"
    >
    <div class="product-list" style="padding: 10px;background-color:#ffffff;-webkit-box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);">
    <a-row :gutter="24">
    <a-col :md="24" :xs="24">
    <sdHeading
    class="product-single-title"
    style="margin: 0% ;text-align: center !important; font-size: 18px; color:#666666;"
    >
    Inbound Queries
    </sdHeading>
    </a-col>
    </a-row>
    <a-row :gutter="24">
    <a-col :md="24" :xs="24" style="text-align: center !important;">
    <div class="product-single-description">
      <sdFeatherIcons type="mail" size="50" style="margin: 0% ;text-align: center !important;color:#7fd9f0"/>
    </div>
    </a-col>
    </a-row>
    <a-row :gutter="24">
    <a-col :md="24" :xs="24">
    <div class="product-single-description">
    <sdHeading
    class="product-single-title"
    style="margin: 0% ;text-align: center !important; font-size: 36px; color:#666666;"
    >
    {{count1}}
    </sdHeading>
    </div>
    </a-col>
    </a-row>
    </div>
    </ProductCard>
    </router-link>
    <router-link to="/sclsprint/2">
    <ProductCard
    class="list-view"
    :style="{ width: '15%', marginBottom: '20px' }"
    >
    <div class="product-list" style="padding: 10px;background-color:#ffffff;-webkit-box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);">
    <a-row :gutter="24">
    <a-col :md="24" :xs="24">
    <sdHeading
    class="product-single-title"
    style="margin: 0% ;text-align: center !important; font-size: 18px; color:#666666;"
    >
    Follow-Ups
    </sdHeading>
    </a-col>
    </a-row>
    <a-row :gutter="24">
    <a-col :md="24" :xs="24" style="text-align: center !important;">
    <div class="product-single-description">
      <sdFeatherIcons type="send" size="50" style="margin: 0% ;text-align: center !important;color:#7fd9f0"/>
    </div>
    </a-col>
    </a-row>
    <a-row :gutter="24">
    <a-col :md="24" :xs="24">
    <div class="product-single-description">
    <sdHeading
    class="product-single-title"
    style="margin: 0% ;text-align: center !important; font-size: 36px; color:#666666;"
    >
    {{count2}}
    </sdHeading>
    </div>
    </a-col>
    </a-row>
    </div>
    </ProductCard>
    </router-link>
    <router-link to="/sclsprint/3">
    <ProductCard
    class="list-view"
    :style="{ width: '15%', marginBottom: '20px' }"
    >
    <div class="product-list" style="padding: 10px;background-color:#ffffff;-webkit-box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);">
    <a-row :gutter="24">
    <a-col :md="24" :xs="24">
    <sdHeading
    class="product-single-title"
    style="margin: 0% ;text-align: center !important; font-size: 18px; color:#666666;"
    >
    Not Connected
    </sdHeading>
    </a-col>
    </a-row>
    <a-row :gutter="24">
    <a-col :md="24" :xs="24" style="text-align: center !important;">
    <div class="product-single-description">
      <sdFeatherIcons type="phone-missed" size="50" style="margin: 0% ;text-align: center !important;color:#7fd9f0"/>
    </div>
    </a-col>
    </a-row>
    <a-row :gutter="24">
    <a-col :md="24" :xs="24">
    <div class="product-single-description">
    <sdHeading
    class="product-single-title"
    style="margin: 0% ;text-align: center !important; font-size: 36px; color:#666666;"
    >
    {{count3}}
    </sdHeading>
    </div>
    </a-col>
    </a-row>
    </div>
    </ProductCard>
    </router-link>
    <router-link to="/sclsprint/4">
    <ProductCard
    class="list-view"
    :style="{ width: '15%', marginBottom: '20px' }"
    >
    <div class="product-list" style="padding: 10px;background-color:#ffffff;-webkit-box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);">
    <a-row :gutter="24">
    <a-col :md="24" :xs="24">
    <sdHeading
    class="product-single-title"
    style="margin: 0% ;text-align: center !important; font-size: 17px; color:#666666;"
    >
    Meetings Scheduled
    </sdHeading>
    </a-col>
    </a-row>
    <a-row :gutter="24">
    <a-col :md="24" :xs="24" style="text-align: center !important;">
    <div class="product-single-description">
      <sdFeatherIcons type="calendar" size="50" style="margin: 0% ;text-align: center !important;color:#7fd9f0"/>
    </div>
    </a-col>
    </a-row>
    <a-row :gutter="24">
    <a-col :md="24" :xs="24">
    <div class="product-single-description">
    <sdHeading
    class="product-single-title"
    style="margin: 0% ;text-align: center !important; font-size: 36px; color:#666666;"
    >
    {{count4}}
    </sdHeading>
    </div>
    </a-col>
    </a-row>
    </div>
    </ProductCard>
    </router-link>
    <router-link to="/sclsprint/5">
    <ProductCard
    class="list-view"
    :style="{ width: '15%', marginBottom: '20px' }"
    >
    <div class="product-list" style="padding: 10px;background-color:#ffffff;-webkit-box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);">
    <a-row :gutter="24">
    <a-col :md="24" :xs="24">
    <sdHeading
    class="product-single-title"
    style="margin: 0% ;text-align: center !important; font-size: 18px; color:#666666;"
    >
    No-Shows
    </sdHeading>
    </a-col>
    </a-row>
    <a-row :gutter="24">
    <a-col :md="24" :xs="24" style="text-align: center !important;">
    <div class="product-single-description">
      <sdFeatherIcons type="phone-off" size="50" style="margin: 0% ;text-align: center !important;color:#7fd9f0"/>
    </div>
    </a-col>
    </a-row>
    <a-row :gutter="24">
    <a-col :md="24" :xs="24">
    <div class="product-single-description">
    <sdHeading
    class="product-single-title"
    style="margin: 0% ;text-align: center !important; font-size: 36px; color:#666666;"
    >
    {{count5}}
    </sdHeading>
    </div>
    </a-col>
    </a-row>
    </div>
    </ProductCard>
    </router-link>
    <router-link to="/sclsprint/6">
    <ProductCard
    class="list-view"
    :style="{ width: '15%', marginBottom: '20px' }"
    >
    <div class="product-list" style="padding: 10px;background-color:#ffffff;-webkit-box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);">
    <a-row :gutter="24">
    <a-col :md="24" :xs="24">
    <sdHeading
    class="product-single-title"
    style="margin: 0% ;text-align: center !important; font-size: 18px; color:#666666;"
    >
    Dead Leads
    </sdHeading>
    </a-col>
    </a-row>
    <a-row :gutter="24">
    <a-col :md="24" :xs="24" style="text-align: center !important;">
    <div class="product-single-description">
      <sdFeatherIcons type="alert-triangle" size="50" style="margin: 0% ;text-align: center !important;color:#7fd9f0"/>
    </div>
    </a-col>
    </a-row>
    <a-row :gutter="24">
    <a-col :md="24" :xs="24">
    <div class="product-single-description">
    <sdHeading
    class="product-single-title"
    style="margin: 0% ;text-align: center !important; font-size: 36px; color:#666666;"
    >
    {{count6}}
    </sdHeading>
    </div>
    </a-col>
    </a-row>
    </div>
    </ProductCard>
    </router-link>
    </div>

    <div headless>
    <router-link to="/sclsprint/7">
    <ProductCard
    class="list-view"
    :style="{ width: '15%', marginBottom: '20px' }"
    >
    <div class="product-list" style="padding: 10px;background-color:#ffffff;-webkit-box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);">
    <a-row :gutter="24">
    <a-col :md="24" :xs="24">
    <sdHeading
    class="product-single-title"
    style="margin: 0% ;text-align: center !important; font-size: 18px; color:#666666;"
    >
    Not Assigned
    </sdHeading>
    </a-col>
    </a-row>
    <a-row :gutter="24">
    <a-col :md="24" :xs="24" style="text-align: center !important;">
    <div class="product-single-description">
      <sdFeatherIcons type="user-x" size="50" style="margin: 0% ;text-align: center !important;color:#7fd9f0"/>
    </div>
    </a-col>
    </a-row>
    <a-row :gutter="24">
    <a-col :md="24" :xs="24">
    <div class="product-single-description">
    <sdHeading
    class="product-single-title"
    style="margin: 0% ;text-align: center !important; font-size: 36px; color:#666666;"
    >
    {{count7}}
    </sdHeading>
    </div>
    </a-col>
    </a-row>
    </div>
    </ProductCard>
    </router-link>
    <router-link to="/sclsprint/8">
    <ProductCard
    class="list-view"
    :style="{ width: '15%', marginBottom: '20px' }"
    >
    <div class="product-list" style="padding: 10px;background-color:#ffffff;-webkit-box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);">
    <a-row :gutter="24">
    <a-col :md="24" :xs="24">
    <sdHeading
    class="product-single-title"
    style="margin: 0% ;text-align: center !important; font-size: 18px; color:#666666;"
    >
    Assigned
    </sdHeading>
    </a-col>
    </a-row>
    <a-row :gutter="24">
    <a-col :md="24" :xs="24" style="text-align: center !important;">
    <div class="product-single-description">
      <sdFeatherIcons type="user-check" size="50" style="margin: 0% ;text-align: center !important;color:#7fd9f0"/>
    </div>
    </a-col>
    </a-row>
    <a-row :gutter="24">
    <a-col :md="24" :xs="24">
    <div class="product-single-description">
    <sdHeading
    class="product-single-title"
    style="margin: 0% ;text-align: center !important; font-size: 36px; color:#666666;"
    >
    {{count8}}
    </sdHeading>
    </div>
    </a-col>
    </a-row>
    </div>
    </ProductCard>
    </router-link>
    <router-link to="/sclsprint/9">
    <ProductCard
    class="list-view"
    :style="{ width: '15%', marginBottom: '20px' }"
    >
    <div class="product-list" style="padding: 10px;background-color:#ffffff;-webkit-box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);">
    <a-row :gutter="24">
    <a-col :md="24" :xs="24">
    <sdHeading
    class="product-single-title"
    style="margin: 0% ;text-align: center !important; font-size: 18px; color:#666666;"
    >
    In-Sales
    </sdHeading>
    </a-col>
    </a-row>
    <a-row :gutter="24">
    <a-col :md="24" :xs="24" style="text-align: center !important;">
    <div class="product-single-description">
      <sdFeatherIcons type="dollar-sign" size="50" style="margin: 0% ;text-align: center !important;color:#7fd9f0"/>
    </div>
    </a-col>
    </a-row>
    <a-row :gutter="24">
    <a-col :md="24" :xs="24">
    <div class="product-single-description">
    <sdHeading
    class="product-single-title"
    style="margin: 0% ;text-align: center !important; font-size: 36px; color:#666666;"
    >
    {{count9}}
    </sdHeading>
    </div>
    </a-col>
    </a-row>
    </div>
    </ProductCard>
    </router-link>
    <router-link to="/sclsprint/10">
    <ProductCard
    class="list-view"
    :style="{ width: '15%', marginBottom: '20px' }"
    >
    <div class="product-list" style="padding: 10px;background-color:#ffffff;-webkit-box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);">
    <a-row :gutter="24">
    <a-col :md="24" :xs="24">
    <sdHeading
    class="product-single-title"
    style="margin: 0% ;text-align: center !important; font-size: 18px; color:#666666;"
    >
    Deal Won
    </sdHeading>
    </a-col>
    </a-row>
    <a-row :gutter="24">
    <a-col :md="24" :xs="24" style="text-align: center !important;">
    <div class="product-single-description">
      <sdFeatherIcons type="briefcase" size="50" style="margin: 0% ;text-align: center !important;color:#7fd9f0"/>
    </div>
    </a-col>
    </a-row>
    <a-row :gutter="24">
    <a-col :md="24" :xs="24">
    <div class="product-single-description">
    <sdHeading
    class="product-single-title"
    style="margin: 0% ;text-align: center !important; font-size: 36px; color:#666666;"
    >
    {{count10}}
    </sdHeading>
    </div>
    </a-col>
    </a-row>
    </div>
    </ProductCard>
    </router-link>
    </div>
    </template>
    </sdPageHeader> 

    <Main>
    <div style="padding: 30px 30px 30px 30px !important; background-color: #fff;  box-shadow: 0 0 10px #ddd;">
    <template v-if="selectedoption == 'Active'">
		<a-row>
          <a-col :md="18">
            <sdHeading as="h3">Query & Follow-Up Trend</sdHeading>
          </a-col>
          <a-col :md="6">
            <sdHeading as="h3" style="text-align: left !important;">Leads Status Break Down</sdHeading>
          </a-col>
        </a-row>

        <!-- CHARTS -->
        <a-row :gutter="24">

          <!-- LINE CHART -->
          <a-col :md="15">
            <div ref="lineChartRef"></div>
          </a-col>

          <!-- HALF DONUT -->
          <a-col :md="9">
            <div ref="pieChartRef"></div>
          </a-col>

        </a-row>
	</template>
      
    </div>
  </Main> 
</template>

<script>
import { Main, TableWrapper } from "../styled";
import { computed, ref, defineComponent, onMounted,reactive} from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { message, Notification } from 'ant-design-vue'; 
import { UserTableStyleWrapper, Action,ContactCardWrapper, ProductCard } from "./style";
import * as FontAwesomeIcon from "@fortawesome/free-solid-svg-icons";
import { setItem, getItem, removeItem } from '/src/utility/localStorageControl';
import { Line, Pie } from "@antv/g2plot";

export default defineComponent({
  name: "dashboard",

  components: {
    Main,
    TableWrapper,
    UserTableStyleWrapper,
    ProductCard,
    ContactCardWrapper,
    FontAwesomeIcon,
    Action,
    
  },
 setup() {
    let empty = ref(true);
    let loading = ref(true);
    const param = useRoute();
    const router = useRouter();
    const { state, dispatch } = useStore();
    var selectedoption = ref('Active');
    var count1 = ref();
    var count2 = ref();
    var count3 = ref();
    var count4 = ref();
    var count5 = ref();
    var count6 = ref();
    var count7 = ref();
    var count8 = ref();
    var count9 = ref();
    var count10 = ref();
    var orgData = ref();
    var dispInterest = ref(false);
    const selectedChange = ref(null);
    var selectrange = ref(null);
    const formState = reactive({
      dateSelection: "",
      domain: "",
      });
    const onChange=(change)=> {
     selectedChange.value=change;
     if(selectedChange.value=="Custom Range"){
     dispInterest.value=true;
     }
     else{
      dispInterest.value=false;
     }
    }  
    const rules = {
      dateSelection: [
        {
          required: true,
          message: "Please select Date Filter",
          trigger: "blur",
        },
      ],
      domain: [
        {
          required: true,
          message: "Please select Domain",
          trigger: "blur",
        },
       
      ],
      };
    const DateSelect = (date, dateString) => {
      selectrange.value = dateString;
    };
    const handleOk = (values) => {
    

      getCount();
    };
    const lineChartRef = ref(null);
    const pieChartRef = ref(null);

    let lineChart = null;
    let pieChart = null;

    /* DATA */
    const lineData = ref([
      { day: "Mon", value: 30, type: "Inbound Queries" },
      { day: "Tue", value: 40, type: "Inbound Queries" },
      { day: "Wed", value: 35, type: "Inbound Queries" },
      { day: "Thu", value: 50, type: "Inbound Queries" },
      { day: "Fri", value: 49, type: "Inbound Queries" },
      { day: "Sat", value: 60, type: "Inbound Queries" },
      { day: "Sun", value: 70, type: "Inbound Queries" },

      { day: "Mon", value: 20, type: "Follow-Ups" },
      { day: "Tue", value: 30, type: "Follow-Ups" },
      { day: "Wed", value: 25, type: "Follow-Ups" },
      { day: "Thu", value: 40, type: "Follow-Ups" },
      { day: "Fri", value: 35, type: "Follow-Ups" },
      { day: "Sat", value: 50, type: "Follow-Ups" },
      { day: "Sun", value: 55, type: "Follow-Ups" },
    ]);

    const pieData = ref([
      { type: "Inbound", value: 10 },
      { type: "Follow-Ups", value: 20 },
      { type: "Not Connected", value: 15 },
      { type: "Meetings", value: 25 },
      { type: "No Shows", value: 10 },
      { type: "Dead Leads", value: 5 },
    ]);

    /* RENDER CHARTS */
    const renderCharts = () => {

      if (lineChart) lineChart.destroy();
      if (pieChart) pieChart.destroy();

      // LINE
      lineChart = new Line(lineChartRef.value, {
        data: lineData.value,
        xField: "day",
        yField: "value",
        seriesField: "type",
        smooth: true,
        height: 320,
      });

      lineChart.render();

      // PIE (HALF DONUT)
     pieChart = new Pie(pieChartRef.value, {
  data: pieData.value,
  angleField: "value",
  colorField: "type",
  radius: 1,
  innerRadius: 0.6,
  startAngle: -Math.PI / 2,
  endAngle: Math.PI / 2,
  height: 320,

  legend: {
    position: "top",
    layout: "horizontal",
    flipPage: false,
    itemName: {
      style: {
        fontSize: 12,
        whiteSpace: "nowrap",
      },
    },
    maxRow: 1,
    itemSpacing: 8,
  },
});
      pieChart.render();
    };

    const API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT;
    state.LeadsData.data = [];
    state.SearchData.data = [];
    onMounted(() => {
      loadOrgData();
      getCount();
      renderCharts();

    });
    const loadOrgData = () => {
      dispatch("manualFieldsData").then((response) => {
        if (response.status == 200) {
          orgData.value = response.data[8];
        }
      });
    };
    const getCount = () => {
      let startdate = null;
      let enddate = null;

      if (selectrange.value) {
        const range = selectrange.value.toString().split(",");
        startdate = new Date(range[0]).toLocaleDateString("en-CA");
        enddate = new Date(range[1]).toLocaleDateString("en-CA");
      }
      localStorage.setItem("dateSelection",formState.dateSelection);
      localStorage.setItem("domain",formState.domain);
      localStorage.setItem("startdate",startdate);
      localStorage.setItem("enddate",enddate);
      let api_data = [];
      api_data['dateSelection'] = formState.dateSelection;
      api_data['domain'] = formState.domain;
      api_data['startdate'] = startdate;
      api_data['enddate'] = enddate;  
      dispatch("getSocialCounts",api_data).then((response) => {
        if (response.status === 200) {
          count1.value = response.data[0];
          count2.value = response.data[1];
          count3.value = response.data[2];
          count4.value = response.data[3];
          count5.value = response.data[4];
          count6.value = response.data[5];
          count7.value = response.data[6];
          count8.value = response.data[7];
          count9.value = response.data[8];
          count10.value = response.data[9];

          pieData.value = [
            //{ type: "Inbound", value: count1.value },
            { type: "Follow-Ups", value: count2.value },
            { type: "Not Connected", value: count3.value },
            { type: "Meetings", value: count4.value },
            { type: "No Shows", value: count5.value },
            { type: "Dead Leads", value: count6.value },
            { type: "Not Assigned", value: count7.value },
            { type: "Assigned", value: count8.value },
            { type: "In-Sales", value: count9.value },
            { type: "Won", value: count10.value },
          ];

          if (pieChart) {
            pieChart.changeData(pieData.value);
          }
        }
      });
    };
    const openurl = (id) => {
      let url = '/index/';
      window.open(
          url + id +'/0',
          "_self",
      ); 
      
    };
      
    return {
      orgData,
      empty,
      loading,
      selectedoption,
      count1,
      count2,
      count3,
      count4,
      count5,
      count6,
      count7,
      count8,
      count9,
      count10,
      lineChartRef,
      pieChartRef,
      handleOk,
      formState,
      selectrange,
      DateSelect,
      rules,
      onChange,
      selectedChange,
      dispInterest,
      };
  },
});
</script>
<style>
.ant-list-items {
  padding-top: 0px !important;
}


.highlighted {
  margin: 10px !important;
  border-spacing: 0 8px !important;
}

.product-list:hover {
  -webkit-box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
  cursor: pointer;
}
.ant-btn-primary {
  background-color: #5C69B3 !important;
  border: 1px solid #5C69B3 !important;
}
.g2-html-annotation {
	display: block !important;
	text-align: left !important;
}
</style>